import type { BillingTier } from "@/lib/api/billing";

/**
 * The words for the model each plan writes on. They are the webapp's own,
 * not the gateway's: Free is Standard, Pro and Max are Advanced. Pure.
 */

const STANDARD = { name: "Standard", description: "A capable, cost-effective model." };
const ADVANCED = {
    name: "Advanced",
    description: "Our most capable model, for sharper tailoring.",
};

export const PLAN_WORDS: Record<BillingTier, { name: string; description: string }> = {
    free: STANDARD,
    pro: ADVANCED,
    max: ADVANCED,
};
